import { combineReducers } from 'redux';
import { LOCATION_DENIED, SET_WAITING_FOR_LOCATION, UPDATE_LOCATION, UPDATE_LOCATION_SUGGESTIONS } from './actionTypes';
export var currentPlace = function currentPlace(state, _ref) {
  if (state === void 0) {
    state = '';
  }

  var type = _ref.type,
      payload = _ref.payload;
  var nextState = state;

  if (type === UPDATE_LOCATION && (payload.currentPlace || payload.isOnline)) {
    nextState = payload.currentPlace;
  }

  return nextState;
};
export var currentPlaceParent = function currentPlaceParent(state, _ref2) {
  if (state === void 0) {
    state = '';
  }

  var type = _ref2.type,
      payload = _ref2.payload;
  var nextState = state;

  if (type === UPDATE_LOCATION && (payload.currentPlaceParent || payload.isOnline)) {
    nextState = payload.currentPlaceParent;
  }

  return nextState;
};
export var city = function city(state, _ref3) {
  if (state === void 0) {
    state = '';
  }

  var type = _ref3.type,
      payload = _ref3.payload;
  var nextState = state;

  if (type === UPDATE_LOCATION && payload.city) {
    nextState = payload.city;
  }

  return nextState;
};
export var region = function region(state, _ref4) {
  if (state === void 0) {
    state = '';
  }

  var type = _ref4.type,
      payload = _ref4.payload;
  var nextState = state;

  if (type === UPDATE_LOCATION && payload.region) {
    nextState = payload.region;
  }

  return nextState;
};
export var suggestions = function suggestions(state, _ref5) {
  if (state === void 0) {
    state = [];
  }

  var type = _ref5.type,
      payload = _ref5.payload;
  var nextState = state;

  if (type === UPDATE_LOCATION_SUGGESTIONS && !payload.suggestions) {
    nextState = payload;
  } else if (type === UPDATE_LOCATION_SUGGESTIONS && payload.suggestions) {
    nextState = payload.suggestions;
  }

  return nextState;
};
export var slug = function slug(state, _ref6) {
  if (state === void 0) {
    state = '';
  }

  var type = _ref6.type,
      payload = _ref6.payload;
  var nextState = state;

  if (type === UPDATE_LOCATION && payload.slug) {
    nextState = payload.slug;
  }

  return nextState;
};
export var placeId = function placeId(state, _ref7) {
  if (state === void 0) {
    state = '';
  }

  var type = _ref7.type,
      payload = _ref7.payload;
  var nextState = state;

  if (type === UPDATE_LOCATION && (payload.placeId || payload.isOnline)) {
    nextState = payload.placeId;
  }

  return nextState;
};

var parseFloatOrNull = function parseFloatOrNull(coordinate) {
  return coordinate ? parseFloat(coordinate) : null;
};

export var latitude = function latitude(state, _ref8) {
  if (state === void 0) {
    state = 0;
  }

  var type = _ref8.type,
      payload = _ref8.payload;
  var nextState = state;

  if (type === UPDATE_LOCATION && (payload.latitude || payload.isOnline)) {
    nextState = parseFloatOrNull(payload.latitude);
  }

  return nextState;
};
export var longitude = function longitude(state, _ref9) {
  if (state === void 0) {
    state = 0;
  }

  var type = _ref9.type,
      payload = _ref9.payload;
  var nextState = state;

  if (type === UPDATE_LOCATION && (payload.longitude || payload.isOnline)) {
    nextState = parseFloatOrNull(payload.longitude);
  }

  return nextState;
};
export var bbox = function bbox(state, _ref10) {
  if (state === void 0) {
    state = 0;
  }

  var type = _ref10.type,
      payload = _ref10.payload;
  var nextState = state;

  if (type === UPDATE_LOCATION && (payload.bbox || payload.isOnline)) {
    nextState = payload.bbox;
  }

  return nextState;
};
export var placeType = function placeType(state, _ref11) {
  if (state === void 0) {
    state = '';
  }

  var type = _ref11.type,
      payload = _ref11.payload;
  var nextState = state;

  if (type === UPDATE_LOCATION && (payload.placeType || payload.isOnline)) {
    nextState = payload.placeType;
  }

  return nextState;
};
export var isEnglishLanguage = function isEnglishLanguage(state, _ref12) {
  if (state === void 0) {
    state = false;
  }

  var type = _ref12.type,
      payload = _ref12.payload;
  var nextState = state;

  if (type === UPDATE_LOCATION && payload.isEnglishLanguage) {
    nextState = payload.isEnglishLanguage;
  }

  return nextState;
};
export var topSuggestions = function topSuggestions(state) {
  if (state === void 0) {
    state = [];
  }

  var nextState = state;
  return nextState;
};
export var cityBlurb = function cityBlurb(state) {
  if (state === void 0) {
    state = '';
  }

  var nextState = state;
  return nextState;
};
export var trendingSearchCities = function trendingSearchCities(state) {
  if (state === void 0) {
    state = [];
  }

  var nextState = state;
  return nextState;
};
export var isWaitingForLocation = function isWaitingForLocation(state, _ref13) {
  if (state === void 0) {
    state = false;
  }

  var type = _ref13.type,
      payload = _ref13.payload;
  var nextState = state;

  if (type === SET_WAITING_FOR_LOCATION) {
    nextState = payload;
  }

  if (type === UPDATE_LOCATION || type === LOCATION_DENIED) {
    nextState = false;
  }

  return nextState;
};
export var isUsingCurrentLocation = function isUsingCurrentLocation(state, _ref14) {
  if (state === void 0) {
    state = false;
  }

  var type = _ref14.type,
      payload = _ref14.payload;
  var nextState = state;

  if (type === UPDATE_LOCATION) {
    nextState = !!payload.isUsingCurrentLocation;
  }

  return nextState;
};
export var locationDenied = function locationDenied(state, _ref15) {
  if (state === void 0) {
    state = false;
  }

  var type = _ref15.type,
      payload = _ref15.payload;
  var nextState = state;

  if (type === LOCATION_DENIED) {
    nextState = payload;
  }

  return nextState;
};
export var isOnline = function isOnline(state, _ref16) {
  if (state === void 0) {
    state = false;
  }

  var type = _ref16.type,
      payload = _ref16.payload;
  var nextState = state;

  if (type === UPDATE_LOCATION) {
    nextState = !!payload.isOnline;
  }

  return nextState;
};
export default combineReducers({
  currentPlace: currentPlace,
  currentPlaceParent: currentPlaceParent,
  city: city,
  region: region,
  suggestions: suggestions,
  slug: slug,
  placeId: placeId,
  latitude: latitude,
  longitude: longitude,
  bbox: bbox,
  placeType: placeType,
  isEnglishLanguage: isEnglishLanguage,
  topSuggestions: topSuggestions,
  cityBlurb: cityBlurb,
  trendingSearchCities: trendingSearchCities,
  isWaitingForLocation: isWaitingForLocation,
  isUsingCurrentLocation: isUsingCurrentLocation,
  locationDenied: locationDenied,
  isOnline: isOnline
});